import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row-metadata" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    class: "q-pa-md table-list-view--container",
    title: "",
    rows: _ctx.items,
    "row-key": row => row?.sys?.id,
    "rows-per-page-options": [0],
    "binary-state-sort": "",
    flat: "",
    "virtual-scroll": "",
    onVirtualScroll: _ctx.onTableScroll,
    "virtual-scroll-item-size": 48,
    "virtual-scroll-sticky-size-start": 48,
    "visible-columns": _ctx.visibleColumns
  }, {
    header: _withCtx((props) => [
      _createVNode(_component_q_tr, { props: props }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "table-header", { entry: props }, undefined, true)
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    body: _withCtx((props) => [
      _createVNode(_component_q_tr, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_td, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "header", {
                row: props,
                entry: props.row,
                index: props.rowIndex
              }, undefined, true),
              _createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "metadata", {
                  row: props,
                  entry: props.row,
                  index: props.rowIndex
                }, undefined, true)
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["props"]),
      _createVNode(_component_q_tr, {
        class: "collapse",
        props: props
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_td, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "body", {
                row: props,
                entry: props.row,
                index: props.rowIndex
              }, undefined, true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    _: 3
  }, 8, ["rows", "row-key", "onVirtualScroll", "visible-columns"]))
}